import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { SBack, SEditor } from 'shj-components'
import styles from './index.module.less'
import {
  Button,
  Col,
  Descriptions,
  FloatButton,
  message,
  Row,
  Spin,
  Tabs,
  Tooltip,
  Typography,
  Image,
} from 'antd'
import starNoFollow from '@/assets/star.png'
import starFollowed from '@/assets/star-fullfill.png'
import { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import FollowModal from '../components/FollowModal'
import {
  favoritesAdd,
  favoritesDelete,
  selectProductSpuDetail,
} from '@/services/goodsFrontendTenant'
import PDFPreview from '@/components/PDFPreview'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import BackToTop from '../components/BackToTop'
import { CopyOutlined, UpOutlined, VerticalAlignTopOutlined } from '@ant-design/icons'

const { Paragraph } = Typography
export default function MaterialDetail() {
  const navaigate = useNavigate()
  const { id, filterGoodsId, filterOrgId } = useParams() // spuId 标配ID
  const [followOpen, setFollowOpen] = useState(false)
  const [detailData, setDetailData] = useState<any>({})
  const [previewObj, setPreviewObj] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [scrollTop, setScrollTop] = useState(false)
  const materialDetailBoxRef = useRef<any>(null)
  const state = useLocation().state
  console.log(state) // 输出：{ name: 'tom', age: "20" }
  useEffect(() => {
    setLoading(true)
    //  获取详情数据
    getDetail()
  }, [])
  const getDetail = () => {
    selectProductSpuDetail({
      productSpuId: id,
      filterGoodsId: filterGoodsId ? filterGoodsId : null,
      filterOrgId: filterOrgId ? filterOrgId : null,
    })
      .then((res: any) => {
        let productDetailList = res?.productSpu?.attachList
        productDetailList = productDetailList?.map((item: any) => {
          return {
            ...item,
            key: _.uniqueId(),
          }
        })
        getDesc(productDetailList || [])
        res.productSku = res.productSku ? res.productSku : res.productSpu?.skuList[0]
        setDetailData(res)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const goBack = () => {
    navaigate('/order/materialSelectionLibrary', { state: { saveCache: true } })
  }
  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }
  const getDesc = (descType: any[]) => {
    const data = descType.map(item => ({
      ...item,
      label: (
        <div>
          <span>{item.attachName}</span>
        </div>
      ),
      children: getDetailType(item.contentType, item),
      key: item.key,
    }))
    setPreviewObj({ descType: data })
  }
  const getDetailType = (type: string, obj) => {
    const { attachPath, content } = obj
    const typeObj = {
      attachContent: <div dangerouslySetInnerHTML={{ __html: content }}></div>,
      attachPDF: <PDFPreview url={attachPath} />,
      attachVideo: <video style={{ width: '100%' }} src={attachPath} controls={true} />,
      attachURL: (
        <Button type="link" onClick={() => openNewWindow(attachPath)}>
          {attachPath}
        </Button>
      ),
    }
    return typeObj[type]
  }
  const priceHandle = (price: number) => {
    if (price) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    }
  }
  const clickToFollow = detailData => {
    // if (detailData?.productSpu?.skuSize <= 1) {
    //   // 但规格不弹窗直接收藏或取消
    //   if (detailData.isFavorite) {
    //     handleToCancelFollow(detailData)
    //   } else {
    //     handleToFollow(detailData)
    //   }
    // } else {
    //   setFollowOpen(true)
    // }
    // if (
    //   detailData?.productSpu?.skuSize > 1 ||
    //   detailData?.productSpu?.combinationInfo?.length > 1 ||
    //   detailData?.productSpu?.skuList[0]?.extField1?.length
    // ) {
    setFollowOpen(true)
    // } else {
    //   // 单规格不弹窗直接收藏或取消
    //   if (detailData.isFavorite) {
    //     handleToCancelFollow(detailData)
    //   } else {
    //     handleToFollow(detailData)
    //   }
    // }
  }
  const handleToFollow = item => {
    let targetId: any = item?.productSpu?.skuList[0]?.id
    let type: any = 'SKU'
    favoritesAdd({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        setDetailData({
          ...detailData,
          isFavorite: true,
        })
        message.success('收藏成功')
      })
      .catch(err => {
        // message.error('收藏失败')
      })
      .finally(() => {})
  }
  const handleToCancelFollow = item => {
    let targetId: any = item?.productSpu?.skuList[0]?.id
    let type: any = 'SKU'
    favoritesDelete({
      type: type,
      targetIds: targetId ? [targetId] : null,
    })
      .then(res => {
        setDetailData({
          ...detailData,
          isFavorite: false,
        })
        message.success('取消成功')
      })
      .catch(err => {
        // message.error('取消失败')
      })
      .finally(() => {})
  }
  // 检测是否需要显示滚动按钮
  const checkScroll = () => {
    if (materialDetailBoxRef.current) {
      const container: any = materialDetailBoxRef.current
      console.log(container.scrollTop)
      if (container.scrollTop > 200) {
        setScrollTop(true)
      } else {
        setScrollTop(false)
      }
    }
  }
  useEffect(() => {
    checkScroll()
    const container: any = materialDetailBoxRef.current
    container?.addEventListener('scroll', checkScroll)
    window.addEventListener('resize', checkScroll)

    return () => {
      container?.removeEventListener('scroll', checkScroll)
      window.removeEventListener('resize', checkScroll)
    }
  }, [])
  // 滚动顶部
  const scrollToTop = () => {
    if (materialDetailBoxRef.current) {
      materialDetailBoxRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }

  const changeProductInfo = (record: any) => {
    console.log(record, 'item')
    const newDetailData = { ...detailData }
    if (record.favorite?.targetId) {
      newDetailData.isFavorite = true
    } else {
      newDetailData.isFavorite = false
    }
    setDetailData({ ...newDetailData })
  }
  return (
    <SBack title={'商品详情'} level={2} goPath={goBack}>
      <div className={styles.detailBack}>
        <Spin spinning={loading}>
          <div className={styles.materialDetailBox} ref={materialDetailBoxRef}>
            <div className={styles.mainBox}>
              <div className={styles.imgBox}>
                {/* <img src={detailData?.productSpu?.mainPicUrl} alt="" /> */}
                <Image src={detailData?.productSpu?.mainPicUrl} />
              </div>
              <div className={styles.infoBox}>
                <div className={styles.titleBox}>
                  <Tooltip title={detailData?.productSpu?.prodName} placement="topLeft">
                    <div className={styles.title}>{detailData?.productSpu?.prodName}</div>
                  </Tooltip>
                  <p className={styles.spuBox}>
                    <span>SPU：</span>
                    {detailData?.productSpu?.id}
                    <CopyOutlined
                      style={{ marginLeft: '8px' }}
                      className="copyIcon"
                      onClick={() => {
                        clickToCopy(detailData?.productSpu?.id)
                      }}
                    />
                  </p>
                </div>
                <div className={styles.desc}>{/* 产品描述 后续迭代 */}</div>
              </div>
              <div className={styles.extraBox}>
                {filterOrgId && (
                  <div className={styles.priceBox}>
                    <span className={styles.priceBoxSmall}>￥</span>
                    {detailData?.minCustomerPrice ? (
                      <>
                        {priceHandle(detailData?.minCustomerPrice)}
                        {detailData?.customerPriceList.length > 1 && (
                          <span className={styles.priceBoxStart}>起</span>
                        )}
                      </>
                    ) : (
                      '--'
                    )}
                  </div>
                )}
                {filterOrgId && (
                  <div>
                    {detailData.isFavorite ? (
                      <Button
                        type="primary"
                        className={styles.followBtn}
                        onClick={() => clickToFollow(detailData)}
                      >
                        取消收藏 <img src={starFollowed} alt="" />
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        className={styles.followBtn}
                        onClick={() => clickToFollow(detailData)}
                      >
                        加入收藏 <img src={starNoFollow} alt="" />
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.sellingPointBox}>{/* 卖点 后续迭代 */}</div>
            <div className={styles.argueBox}>
              <div className={styles.RowBox}>
                <div className={styles.labelBox}>品牌</div>
                <div className={styles.contentBox}>{detailData?.productSpu?.brandName || '-'}</div>
                <div className={styles.labelBox}>单位</div>
                <div className={styles.contentBox}>
                  {' '}
                  {detailData?.productSpu?.unitInfo?.unitName || '-'}
                </div>
              </div>
              <div className={styles.RowBox}>
                <div className={styles.labelBox}>起订数</div>
                <div className={styles.contentBox}>
                  {detailData?.productSpu?.minOrderQuantity || '-'}
                </div>
                <div className={styles.labelBox}>产地</div>
                <div className={styles.contentBox}> {detailData?.productSpu?.origin || '-'}</div>
              </div>
              <div className={styles.RowBox}>
                <div className={styles.labelBox}>生产周期</div>
                <div className={styles.contentBox}>
                  {detailData?.productSpu?.purchaseLeadTime
                    ? `${detailData?.productSpu?.purchaseLeadTime}天`
                    : '-'}
                </div>
                <div className={styles.labelBox}>风格</div>
                <div className={styles.contentBox}>{detailData?.productSpu?.styleNames || '-'}</div>
              </div>
              <div className={styles.RowBox}>
                <div className={styles.labelBox}>卖点</div>
                <div className={styles.contentBox}>
                  {detailData?.productSpu?.sellingPoint || '-'}
                </div>
                <div className={styles.labelBox}>备注</div>
                <div className={styles.contentBox}>
                  {detailData?.productSpu?.materialRemark || '-'}
                </div>
              </div>
            </div>
            {previewObj.descType?.length ? (
              <div className={styles.productDetailBox}>
                {' '}
                <Tabs items={previewObj.descType} hideAdd />{' '}
              </div>
            ) : null}
            <div className={styles.careInstructionsBox}>
              <div className={styles.RowBox}>
                <div className={styles.labelBox}>保养说明</div>
                <div className={styles.contentBox}>
                  {detailData?.productSpu?.maintenanceDesc || '-'}
                </div>
              </div>
            </div>
          </div>
          {scrollTop && (
            <FloatButton
              icon={<UpOutlined />}
              onClick={scrollToTop}
              // className="back-to-top"
              tooltip="返回顶部"
            />
          )}
        </Spin>
      </div>

      {followOpen && (
        <FollowModal
          open={followOpen}
          onClose={() => {
            setFollowOpen(false)
          }}
          record={detailData}
          changeProductInfo={changeProductInfo}
          fetchParams={{ filterOrgId }}
        ></FollowModal>
      )}
    </SBack>
  )
}
